import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';

interface IExpenseProps {
  show: boolean;
  onClose: () => void;
}

const Expense = ({ show = false, onClose = () => {} }: IExpenseProps) => {
  const [name, setName] = useState<string>('');
  const [type, setType] = useState<string>('expense');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  const handleCancel = () => {
    setName('');
    setType('expense');
    setStartDate('');
    setEndDate('');
    onClose();
  };

  const handleSave = () => {
    axios
      .post('/api/expense', {
        name,
        type,
        ...(type === 'trip' && {
          start_date: startDate,
          end_date: endDate,
        }),
      })
      .then(() => {
        handleCancel();
      });
  };

  return (
    <Modal show={show} onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>New expense</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="name"
              type="text"
              value={name}
              onChange={(i) => setName(i.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Type</Form.Label>
            <Form.Select
              aria-label="Select type"
              size="sm"
              className="text-center"
              value={type}
              onChange={(e) => {
                setType(e.target.value);
                if (e.target.value === 'expense') {
                  setStartDate('');
                  setEndDate('');
                }
              }}
            >
              <option value={'expense'}>Expense</option>
              <option value={'trip'}>Trip</option>
            </Form.Select>
          </Form.Group>
          {type === 'trip' && (
            <Form.Group className="mt-3">
              <Form.Label>Start date</Form.Label>
              <Form.Control
                name="start_date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
              <Form.Label className="mt-2">End date</Form.Label>
              <Form.Control
                name="end_date"
                type="date"
                value={endDate}
                min={startDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Expense;
